import { Button } from "antd";
import { LabelledInput, LabelledSelect } from "../Fields";
import useAdBlockStore from "store/AdBlockStore";
import { useDataStore } from "store/DataStore";
import { sizeDisablingUnits, getSizeType } from "utils";

const SelectSizeUnit = ({ label, value, onChange, categoryUnits, allUnits, disabled, ...props }) => (
  <LabelledSelect
    label={label}
    value={value}
    onChange={onChange}
    options={[
      {
        label: 'Category Units',
        options: categoryUnits.map(item => ({
          value: item.id,
          label: item.title
        }))
      },
      {
        label: 'Other Units',
        options: allUnits
          .filter(item => !categoryUnits.some(categoryItem => categoryItem.id === item.id))
          .map(item => ({
            value: item.id,
            label: item.title
          }))
      }
    ]}
    disabled={disabled}
    {...props}
  />
);

export const SinglePlusDimension = () => {
  const productSizes = useDataStore((state) => state.productSizes);
  const currentProduct = useAdBlockStore((state) => state.currentProduct);
  const updateCurrentProduct = useAdBlockStore((state) => state.updateCurrentProduct);
  const setActiveField = useAdBlockStore((state) => state.setActiveField);
  const focusNextField = useAdBlockStore((state) => state.focusNextField);

  return (
    <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
      <div
        style={{ width: '60%' }}
      >
        <SelectSizeUnit
          label="ext_size_unit"
          value={currentProduct?.ext_size_unit_i || ""}
          onChange={(value) => {
            if (sizeDisablingUnits.includes(value)) {
              updateCurrentProduct({ size_1: "" })
            }
            updateCurrentProduct({ ext_size_unit_i: value })
            setTimeout(() => focusNextField("product-builder"), 0);
          }}
          categoryUnits={currentProduct?.sizes || []}
          allUnits={productSizes}
          disabled={false}
          onFocus={() => setActiveField("ext_size_unit_i")}
        />
      </div>
      <div
        style={{ width: '35%' }}
      >
        <LabelledInput
          label="size_1"
          placeholder="Enter product size"
          allowclear="true"
          type={`${getSizeType({value: currentProduct?.ext_size_unit_i}, productSizes)}-calc`}
          value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i) ? "" : currentProduct?.size_1 || ""}
          onChange={(value) => updateCurrentProduct({ size_1: value })}
          disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i)}
          onFocus={() => setActiveField("size_1")}
        />
      </div>
    </div>
  )
};

export const RangeAreaDimension = () => {
  const productSizes = useDataStore((state) => state.productSizes);
  const currentProduct = useAdBlockStore((state) => state.currentProduct);
  const updateCurrentProduct = useAdBlockStore((state) => state.updateCurrentProduct);
  const setActiveField = useAdBlockStore((state) => state.setActiveField);
  const focusNextField = useAdBlockStore((state) => state.focusNextField);

  return (
    <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
      <div
        style={{ width: '50%' }}
      >
        <SelectSizeUnit
          label="ext_size_unit"
          value={currentProduct?.ext_size_unit_i || ""}
          onChange={(value) => {
            if (sizeDisablingUnits.includes(value)) {
              updateCurrentProduct({ size_1: "", size_2: "" })
            }
            updateCurrentProduct({ ext_size_unit_i: value })
            setTimeout(() => focusNextField("product-builder"), 0);
          }}
          categoryUnits={currentProduct?.sizes || []}
          allUnits={productSizes}
          disabled={false}
          onFocus={() => setActiveField("ext_size_unit_i")}
        />
      </div>
      <div
        style={{ width: '24%' }}
      >
        <LabelledInput
          label="size_1"
          placeholder="Select product size..."
          allowclear="true"
          value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i) ? "" : currentProduct?.size_1 || ""}
          onChange={(value) => updateCurrentProduct({ size_1: value })}
          disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i)}
          onFocus={() => setActiveField("size_1")}
        />
      </div>
      <div
        style={{ width: '24%' }}
      >
        <LabelledInput
          label="size_2"
          placeholder="Select product size..."
          allowclear="true"
          value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i) ? "" : currentProduct?.size_2 || ""}
          onChange={(value) => updateCurrentProduct({ size_2: value })}
          disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i)}
          onFocus={() => setActiveField("size_2")}
        />
      </div>
    </div>
  )
};

export const SizeAndQtyDimension = () => {
  const productSizes = useDataStore((state) => state.productSizes);
  const currentProduct = useAdBlockStore((state) => state.currentProduct);
  const updateCurrentProduct = useAdBlockStore((state) => state.updateCurrentProduct);
  const setActiveField = useAdBlockStore((state) => state.setActiveField);
  const focusNextField = useAdBlockStore((state) => state.focusNextField);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '50%' }}>
          <SelectSizeUnit
            label="ext_size_unit"
            value={currentProduct?.ext_size_unit_i || ""}
            onChange={(value) => {
              if (sizeDisablingUnits.includes(value)) {
                updateCurrentProduct({ size_1: "", size_2: "" })
              }
              updateCurrentProduct({ ext_size_unit_i: value })
              setTimeout(() => focusNextField("product-builder"), 0);
            }}
            categoryUnits={currentProduct?.sizes || []}
            allUnits={productSizes}
            disabled={false}
            onFocus={() => setActiveField("ext_size_unit_i")}
          />
        </div>
        <div style={{ width: '24%' }}>
          <LabelledInput
            label="size_1"
            placeholder="Select product size..."
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i) ? "" : currentProduct?.size_1 || ""}
            onChange={(value) => updateCurrentProduct({ size_1: value })}
            disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i)}
            onFocus={() => setActiveField("size_1")}
          />
        </div>
        <div style={{ width: '24%' }}>
          <LabelledInput
            label="size_2"
            placeholder="Enter quantity..."
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i) ? "" : currentProduct?.size_2 || ""}
            onChange={(value) => updateCurrentProduct({ size_2: value })}
            disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i)}
            onFocus={() => setActiveField("size_2")}
          />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '50%' }}>
          <SelectSizeUnit
            label="ext_size_unit_2"
            value={currentProduct?.ext_size_unit_2_i || ""}
            onChange={(value) => {
              if (sizeDisablingUnits.includes(value)) {
                updateCurrentProduct({ size_3: "", size_4: "" })
              }
              updateCurrentProduct({ ext_size_unit_2_i: value })
              setTimeout(() => focusNextField("product-builder"), 0);
            }}
            categoryUnits={currentProduct?.sizes || []}
            allUnits={productSizes}
            disabled={false}
            onFocus={() => setActiveField("ext_size_unit_2_i")}
          />
        </div>
        <div style={{ width: '24%' }}>
          <LabelledInput
            label="size_3"
            placeholder="Select product size..."
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i) ? "" : currentProduct?.size_3 || ""}
            onChange={(value) => updateCurrentProduct({ size_3: value })}
            disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i)}
            onFocus={() => setActiveField("size_3")}
          />
        </div>
        <div style={{ width: '24%' }}>
          <LabelledInput
            label="size_4"
            placeholder="Enter quantity..."
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i) ? "" : currentProduct?.size_4 || ""}
            onChange={(value) => updateCurrentProduct({ size_4: value })}
            disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i)}
            onFocus={() => setActiveField("size_4")}
          />
        </div>
      </div>
    </div>
  )
};

export const RangeDoubleSizeDimension = () => {
  const productSizes = useDataStore((state) => state.productSizes);
  const currentProduct = useAdBlockStore((state) => state.currentProduct);
  const updateCurrentProduct = useAdBlockStore((state) => state.updateCurrentProduct);
  const setActiveField = useAdBlockStore((state) => state.setActiveField);
  const focusNextField = useAdBlockStore((state) => state.focusNextField);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '70%' }}>
          <SelectSizeUnit
            label="ext_size_unit"
            value={currentProduct?.ext_size_unit_i || ""}
            onChange={(value) => {
              if (sizeDisablingUnits.includes(value)) {
                updateCurrentProduct({ size_1: "" })
              }
              updateCurrentProduct({ ext_size_unit_i: value })
              setTimeout(() => focusNextField("product-builder"), 0);
            }}
            categoryUnits={currentProduct?.sizes || []}
            allUnits={productSizes}
            disabled={false}
            onFocus={() => setActiveField("ext_size_unit_i")}
          />
        </div>
        <div style={{ width: '28%' }}>
          <LabelledInput
            label="size_1"
            placeholder="Select product size..."
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i) ? "" : currentProduct?.size_1 || ""}
            onChange={(value) => updateCurrentProduct({ size_1: value })}
            disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i)}
            onFocus={() => setActiveField("size_1")}
          />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '70%' }}>
          <SelectSizeUnit
            label="ext_size_unit_2"
            value={currentProduct?.ext_size_unit_2_i || ""}
            onChange={(value) => {
              if (sizeDisablingUnits.includes(value)) {
                updateCurrentProduct({ size_2: "" })
              }
              updateCurrentProduct({ ext_size_unit_2_i: value })
              setTimeout(() => focusNextField("product-builder"), 0);
            }}
            categoryUnits={currentProduct?.sizes || []}
            allUnits={productSizes}
            disabled={false}
            onFocus={() => setActiveField("ext_size_unit_2_i")}
          />
        </div>
        <div style={{ width: '28%' }}>
          <LabelledInput
            label="size_2"
            placeholder="Select product size..."
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i) ? "" : currentProduct?.size_2 || ""}
            onChange={(value) => updateCurrentProduct({ size_2: value })}
            disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i)}
            onFocus={() => setActiveField("size_2")}
          />
        </div>
      </div>
    </div>
  )
};

export const TotalSizeDimension = () => {
  const productSizes = useDataStore((state) => state.productSizes);
  const currentProduct = useAdBlockStore((state) => state.currentProduct);
  const updateCurrentProduct = useAdBlockStore((state) => state.updateCurrentProduct);
  const setActiveField = useAdBlockStore((state) => state.setActiveField);
  const focusNextField = useAdBlockStore((state) => state.focusNextField);

  
  const calculateIndividualSize = (e) => {
    e.preventDefault();

    if (currentProduct.size_1) {
      if (currentProduct.size_3) {
        updateCurrentProduct({ size_3: Number(currentProduct.size_3 / currentProduct.size_1).toFixed(2) });
      }
      if (currentProduct.size_4) {
        updateCurrentProduct({ size_4: Number(currentProduct.size_4 / currentProduct.size_1).toFixed(2) });
      }
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '70%' }}>
          <SelectSizeUnit
            label="ext_size_unit"
            value={currentProduct?.ext_size_unit_i || ""}
            onChange={(value) => {
              updateCurrentProduct({ ext_size_unit_i: value })
              setTimeout(() => focusNextField("product-builder"), 0);
            }}
            categoryUnits={currentProduct?.sizes || []}
            allUnits={productSizes}
            disabled={false}
            onFocus={() => setActiveField("ext_size_unit_i")}
          />
        </div>
        <div style={{ width: '28%' }}>
          <LabelledInput
            label="Count"
            placeholder="Count"
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i) ? "" : currentProduct?.size_1 || ""}
            onChange={(value) => updateCurrentProduct({ size_1: value })}
            disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_i)}
            onFocus={() => setActiveField("size_1")}
          />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
        <div style={{ width: '40%' }}>
          <SelectSizeUnit
            label="ext_size_unit_2"
            value={currentProduct?.ext_size_unit_2_i || ""}
            onChange={(value) => {
              updateCurrentProduct({ ext_size_unit_2_i: value })
              setTimeout(() => focusNextField("product-builder"), 0);
            }}
            categoryUnits={currentProduct?.sizes || []}
            allUnits={productSizes}
            disabled={false}
            onFocus={() => setActiveField("unit")}
          />
        </div>
        <div style={{ width: '28%' }}>
          <LabelledInput
            label="Total Size 1"
            placeholder="Total Size 1"
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i) ? "" : currentProduct?.size_3 || ""}
            onChange={(value) => updateCurrentProduct({ size_3: value })}
          />
        </div>
        <div style={{ width: '28%' }}>
          <LabelledInput
            label="Total Size 2"
            placeholder="Total Size 2"
            allowclear="true"
            value={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i) ? "" : currentProduct?.size_4 || ""}
            onChange={(value) => updateCurrentProduct({ size_4: value })}
            disabled={sizeDisablingUnits.includes(currentProduct?.ext_size_unit_2_i)}
            onFocus={() => setActiveField("size_4")}
          />
        </div>
      </div>
      <Button type="dashed" style={{ width: '100%' }} onClick={calculateIndividualSize}>
        Calculate Individual Size
      </Button>
    </div>
  )
};
